import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import Formsy from "formsy-react";
import { Input, Checkbox } from "formsy-react-components";
import RichTextEditor from "react-rte";
import "./ProjectNoteForm.scss";

class ProjectNoteForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false,
      isValidNote: true,
      value: RichTextEditor.createEmptyValue()
    };
  }

  componentDidMount = () => {
    const { note } = this.props;
    if (note.note) {
      this.setState({
        value: RichTextEditor.createValueFromString(
          this.props.note.note,
          "html"
        )
      });
    }
  };

  onChange = (value) => {
    const note = value.toString("html");
    const canSubmit = note && note.length < 2000;
    this.setState({ value, canSubmit, isValidNote: canSubmit });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  add = (model) => {
    model.note = this.state.value.toString("html");
    this.props.onAdd(model);
  };

  submit = (model) => {
    model.id = this.props.note._id;
    model.note = this.state.value.toString("html");
    this.props.onSave(model);
  };

  cancel = () => {
    this.props.onCancel();
  };

  render() {
    const { note, adding } = this.props;
    const { isValidNote } = this.state;
    return (
      <Formsy
        ref={(ref) => (this.form = ref)}
        className="vertical form"
        onValidSubmit={adding ? this.add : this.submit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
      >
        <Row>
          <Col md={9} xs={12}>
            <Input
              required
              name="title"
              label="Title"
              value={note.title}
              validations={{ maxLength: 250 }}
              validationErrors={{
                maxLength: "You can not type in more than 250 characters"
              }}
            />
          </Col>
          <Col md={3} xs={12}>
            <Checkbox
              formNoValidate
              name="is_manager_note"
              valueLabel="Include in Digest"
              value={note.is_manager_note}
            />
          </Col>
          <Col md={12} xs={12}>
            <RichTextEditor
              className={this.props.auth.isNightMode ? "dark" : ""}
              value={this.state.value}
              onChange={this.onChange}
            />
            {!isValidNote && (
              <p
                style={{
                  color: "red",
                  fontWeight: "bolder",
                  padding: "0.75rem"
                }}
              >
                You can not type in more than 2000 characters.
              </p>
            )}
          </Col>
          <Col md={12} xs={12} className="footer">
            <button
              type="button"
              className="btn  btn-cancel"
              onClick={this.cancel}
            >
              Cancel
            </button>
            <input
              className="btn btn-success"
              type="submit"
              disabled={
                !isValidNote || !this.state.canSubmit || this.props.saving
              }
              value={this.props.saving ? "Saving... " : "Save"}
            />
          </Col>
        </Row>
      </Formsy>
    );
  }
}

ProjectNoteForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  note: PropTypes.object,
  onAdd: PropTypes.func,
  adding: PropTypes.bool,
  auth: PropTypes.object
};

export default ProjectNoteForm;
